// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5690":"fbf639b6","8688":"a7092b5f","8950":"defd12b5"}[chunkId] + ".chunk.css";
};